export const generatePdfName = (url: string = '', mode: string) => {
    const filePath = (url || '').split('?')[0].split('/')
    return `${filePath[3]}-${filePath[5]}-${filePath[6]}${mode === 'months' ? `-${filePath[7]}` : ''}`
}